<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">My Jobs
                </b-card-title>
            </b-card-header>
        </b-card>

        <b-tabs pills class="tab-jobs-garden-help mt-3" v-model="tabIndex" @input="changeTab">
            <b-tab title="New Jobs" lazy>
                <JobsTable type="pending" />
            </b-tab>
            <b-tab title="Current Jobs" lazy>
                <JobsTable type="current" />
            </b-tab>
            <b-tab title="Job Requests" lazy>
                <JobsTable type="requests" />
            </b-tab>
            <b-tab title="History" lazy>
                <JobsTable type="history" />
            </b-tab>
            <b-tab title="Quotes" lazy v-if="!is_staff">
                <QuotesTable type="requests" />
                <QuotesTable type="quotes" />
            </b-tab>
        </b-tabs>

    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";

import JobsTable from "./JobsTable.vue";
import QuotesTable from "../../quotes/QuotesTable.vue"

export default {
    name: "GardenHelpMyJobs",
    components: { JobsTable, QuotesTable },
    data() {
        return {
            client_name: "GARDENHELP",
            tabIndex: 1,

            is_staff: false
        }
    },

    methods: {
        changeTab(tabIndex) {
            console.log("change tab", tabIndex)
        },
    },
    beforeMount() {

        console.log(this.$route.query)
        console.log(this.$route.query.type == null)
        if (this.$route.query.type == null) {
            this.tabIndex = 0
        } else {
            this.tabIndex = 4
        }
    },
    mounted() {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.is_staff = user.is_staff
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/my_jobs/Index.vue